/* eslint-disable no-unused-vars */
export default {
    init() {
        /* See sites/www.ispot.tv/module/Application/view/layout/slim/partials/body/footer/contact.phtml */
        const clearbitRisk = '/ajax/users/clearbitrisk';

        /* Targets */
        const formTargetClass = '.js-getADemoForm';
        const emailInputClass = '.js-getADemoEmail';
        const submitBtnClass = '.js-getADemoSubmitBtn';
        const formErrorClass = '.js-getADemoError';

        const targets = document.querySelectorAll(formTargetClass);

        /* TODO: This belongs in a utils library. */
        const createCookie = function (cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            const expires = `expires=${d.toUTCString()}`;
            document.cookie = `${cname}=${cvalue};${expires};path=/`;
        };

        /* TODO: This belongs in a utils library. */
        const createCookieFromInputValue = function (cookieName, target, expire = 365) {
            const el = document.querySelector(target);
            if (el && el.value) {
                createCookie(cookieName, el.value, expire);
            }
        };

        /* TODO: This belongs in a utils library. */
        const upperCaseFirstChar = function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        };

        /* TODO: This belongs in a utils library. */
        const lowerCaseFirstChar = function (string) {
            if (!string.charAt(0)) {
                return string;
            }
            return string.charAt(0).toLowerCase() + string.slice(1);
        };

        /* TODO: This belongs in a utils library. */
        const triggerClick = function (elem) {
            /* Create our event (with options) */
            const evt = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
            });
            /* If cancelled, don't dispatch our event */
            const canceled = !elem.dispatchEvent(evt);
            if (canceled) {
                console.error('Click Cancelled: A handler called preventDefault');
            }
        };

        const getInputName = function (stack, sublist, property) {
            const subListName = !sublist ? upperCaseFirstChar(property) : '';
            return stack ? lowerCaseFirstChar(stack) + subListName : '';
        };

        const getInputValue = function (value, sublist) {
            let newVal = value;
            if (sublist) {
                [newVal] = sublist;
                for (let i = 1; i < sublist.length; i += 1) {
                    newVal += `, ${sublist[i]}`;
                }
            }
            return newVal;
        };

        const drawClearbitField = function (name, value, form) {
            const formInput = document.createElement('input');
            formInput.setAttribute('name', name);
            formInput.setAttribute('value', value);
            formInput.setAttribute('type', 'hidden');

            form.appendChild(formInput);
        };

        const initClearbitFields = function (obj, form, stack, sublist) {
            const keys = Object.keys(obj);
            for (let i = 1; i < keys.length; i += 1) {
                const item = keys[i];
                if (obj[item] && typeof obj[item] === 'object') {
                    /* Recursively build inputs. */
                    const newSublist = obj[item] && obj[item].length > 0 ? obj[item] : '';
                    const newStack = (stack || '') + upperCaseFirstChar(item);
                    initClearbitFields(obj[item], form, newStack, newSublist);
                } else if (stack !== undefined && obj[item] !== null) {
                    /* Draw input. */
                    const inputName = getInputName(stack, sublist, item);
                    const inputValue = getInputValue(obj[item], sublist);
                    drawClearbitField(inputName, inputValue, form);
                }
                // if (obj === sublist) {
                //     return false;
                // }
                // return true;
            }
        };

        const drawError = function (text, form) {
            const formError = form.querySelector(formErrorClass);
            formError.innerHTML = text;
            formError.classList.remove('hidden');

            const submitBtn = form.querySelector(submitBtnClass);
            submitBtn.disabled = false;
        };

        const clearError = function (form) {
            const formError = form.querySelector(formErrorClass);
            formError.innerHTML = '';
            formError.classList.add('hidden');
        };

        const postToClearbit = function (email, csrfToken, action, callback, form) {
            clearError(form);

            if (!email) {
                drawError('Please enter a valid email address.', form);
                return;
            }

            const request = new XMLHttpRequest();
            request.open('POST', action, true);
            request.withCredentials = true;
            request.onreadystatechange = function () {
                if (request.readyState !== XMLHttpRequest.DONE) {
                    return;
                }
                if (!(request.status === 0 || (request.status >= 200 && request.status < 400))) {
                    drawError('Sorry, there was an unexpected error. Please try again.', form);
                    return;
                }
                callback(JSON.parse(request.response), form);
            };
            request.setRequestHeader('Accept', 'application/json, text/javascript, */*; q=0.01');
            /* eslint-disable max-len */
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            /* eslint-enable max-len */
            request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            request.setRequestHeader('Access-Control-Allow-Origin', window.location.origin);
            request.send(`email=${encodeURIComponent(email)}&csrfToken=${encodeURIComponent(csrfToken)}`);
        };

        const handleClearbitRisk = function (response, form) {
            /* The request has been completed successfully */
            const data = response[0];

            if (data.error) {
                drawError(data.error, form);
                return;
            }

            if (data.disposable === true
                || data.blacklisted === true
                || data.freeProvider === true
                || data.emailvalidity === false) {
                drawError('Please provide a valid business email address', form);
                return;
            }

            clearError(form);

            drawClearbitField('riskLevel', data.level, form);
            drawClearbitField('riskScore', data.score, form);

            const emailInput = form.querySelector(emailInputClass);
            const inputValue = emailInput.value;
            createCookie('sf_3', inputValue, 365);
            createCookieFromInputValue('pi_fn', 'input[name=first_name]', 365);
            createCookieFromInputValue('pi_ln', 'input[name=last_name]', 365);
            createCookieFromInputValue('pi_cn', 'input[name=company]', 365);

            /* Update form action to point to clearbit enrich. */
            /* eslint-disable max-len */
            form.setAttribute('action', `https://www2.ispot.tv/l/797423/2021-03-10/75vpy?success_location=${window.location.origin}/contact-sales`);
            /* eslint-enable max-len */
            const submitBtn = form.querySelector(submitBtnClass);
            submitBtn.disabled = false;

            triggerClick(submitBtn);
        };

        const handleSubmit = function (e) {
            const form = e.target;
            const submitButton = form.querySelector(submitBtnClass);
            submitButton.disabled = true;

            const emailInput = form.querySelector(emailInputClass);
            const inputValue = emailInput.value;

            const csrfInput = form.querySelector('.csrfToken');
            const csrfToken = csrfInput.value;

            const { action } = form;

            if (!csrfInput.value) {
                e.preventDefault();
                return;
            }

            if (action.indexOf(clearbitRisk) > 0) {
                e.preventDefault();
                postToClearbit(inputValue, csrfToken, clearbitRisk, handleClearbitRisk, form);
                return;
            }

            clearError(form);
        };

        targets.forEach((t) => {
            t.addEventListener('submit', handleSubmit);
        });
    },
};
